<template>
<ShowControl  @revert="revertClick" @close="close"  :title="title" ref="showControl" v-loading="loadings">
    <div id="Main">
      <div v-for="(o, index) in explist"
           :key="index"
           style="position: relative">
        <el-card :body-style="{ padding: '0px' }"
                 style="text-align: center">

                 <el-image v-if="o.id==598" :src="
              require('../images/zjbj1.png')
            "
                    :fit="fit"
                    style="width:calc(100vw *  300 / 1920);height: calc(100vw * 200 / 1920);margin-top: 20px;;"></el-image>
                    <el-image v-else-if="o.id!==598" :src="
              require('../images/zjbg.png')
            "
                    :fit="fit"
                    style="width:calc(100vw *  300 / 1920);height: calc(100vw * 200 / 1920);margin-top: 20px;;"></el-image>
                    <div style="    float: left;
    position: absolute;
    right: 10px;
    top: 10px; z-index: 999;"> 
    <el-button v-if="o.id==598" type="success" disabled>已完成</el-button>
     <el-button v-else  type="primary" disabled>进行中</el-button>
          </div>
          <div style="padding: 14px; font-size: 22px; font-weight: bold">

            <p>活动名称:{{ o.name }}</p>
            <p style="font-size: 16px">{{filter.formatDate( o.createTime , "yyyy年M月d日")}}</p>
            <div>
              <el-collapse>
                <el-collapse-item title="详情">
                  <div>{{ o.describe }}</div>
                </el-collapse-item>
              </el-collapse>
              <!-- <el-tooltip :content="o.describe"
                          popper-class="tool-tip">
                <p style="font-size: 14px;display: -webkit-box;    
      -webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden;height: 75px;margin-top: 5px;">{{ o.describe }}</p>
              </el-tooltip> -->

            </div>
          </div>
          <div></div>
          <el-dropdown class="user-name"
                     trigger="click"
                     @command="handleCommand" style="margin-right: 10px;">
            <el-button type="primary">实验预习</el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <!-- <el-dropdown-item divided :command="composeValue(o.id,'loginout')">
                  课件资料
                  <el-submenu>
                    <template #title>新的一级菜单</template>
                    <el-dropdown-item divided :command="composeValue(o.id,'subitem2')">教学指导书</el-dropdown-item>
                    <el-dropdown-item divided :command="composeValue(o.id,'subitem1')">课件</el-dropdown-item>
                  </el-submenu>
                </el-dropdown-item> -->
                                  <el-dropdown-item divided
                                  :command="composeValue(o.groupID,'histpry')">虚拟场景</el-dropdown-item>
                                  <el-dropdown-item divided
                                  :command="composeValue(o.groupID,'guide')">操作引导</el-dropdown-item>
                                  <el-dropdown-item divided
                                  :command="composeValue(o.id,'topic')" >预习测试</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-button type="primary"
                     @click="Selectbtn(o)"
                     style="text-align: center; margin-bottom: 20px">进入实验</el-button>
          <!-- <el-button type="primary"
                     style="text-align: center;margin-bottom: 20px;"
                     @click="initGuide()">查看引导</el-button>

                     <el-button type="primary"
                     style="text-align: center;margin-bottom: 20px;"
                     @click="history()">场景图</el-button> -->
          <div class="
                     tagdiv">{{ o.state }}
          </div>
        </el-card>
      </div>
      <div v-if="explist.length==0">
        <p style="display: flex;flex-direction: column;margin: 0 !important;position: absolute; top: 50%;left: 50%;transform: translate(-50%,-50%);font-weight: 300;">暂无数据</p>
      </div>
    </div>
  </ShowControl>
</template>

<script>
import { mapState } from "vuex";
import ShowControl from "./UserControl/ShowControl.vue"
import Cookie from "js-cookie";
export default {
  components:{
    ShowControl
  },
  data () {
    return {
      currentDate: new Date(),
      explist: [],
      introOption: { // 参数对象
        prevLabel: '上一步',
        nextLabel: '下一步',
        skipLabel: '跳过',
        doneLabel: '完成',
        tooltipClass: 'intro-tooltip', /* 引导说明文本框的样式 */
        // highlightClass: 'intro-highlight', /* 说明高亮区域的样式 */
        exitOnEsc: true, /* 是否使用键盘Esc退出 */
        exitOnOverlayClick: false, /* 是否允许点击空白处退出 */
        keyboardNavigation: true, /* 是否允许键盘来操作 */
        showBullets: false, /* 是否使用点显示进度 */
        showProgress: true, /* 是否显示进度条 */
        scrollToElement: true, /* 是否滑动到高亮的区域 */
        overlayOpacity: 0.5, // 遮罩层的透明度 0-1之间
        positionPrecedence: ['bottom', 'top', 'right', 'left'], /* 当位置选择自动的时候，位置排列的优先级 */
        disableInteraction: false, /* 是否禁止与元素的相互关联 */
        hidePrev: true, /* 是否在第一步隐藏上一步 */
        hideNext: true, /* 是否在最后一步隐藏下一步 */
        steps: [], /* steps步骤，可以写个工具类保存起来 */
      },
      title: '实验列表'
    };
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
    }),
  },
  mounted() {

  },
  created () {
    this.explist = JSON.parse(localStorage.getItem("selectiveexperiment"));
    // if(this.$route.query.score!=undefined){
    //   let userNames = localStorage.getItem("ms_username");
    //   console.log(userNames);
    //   var parm = 
    //   {
    //     score:parseInt(this.$route.query.score),
    //     userName : userNames,
    //     expId : parseInt(this.$route.query.expId)
    //   }
    //   this.$http
    //     .post(
    //       "StudentData/UpdateTopicScore",parm
    //     )
    //     .then((res) => {
    //       if (res.success) {
    //         console.log(res.success);
    //       } else {
    //         return this.$message.warning(res.message);
    //       }
    //     });
    // }
  },
  methods: {
    close(){
      localStorage.removeItem("ms_username");
      localStorage.removeItem("dis");
      localStorage.removeItem("access_tokenExp");
      localStorage.removeItem("create_time");
      localStorage.removeItem("un");
      this.$router.push("/login");
    },
    handleMessage(event) {
      if (event.origin === 'https://example.com') {
        const message = event.data;
        if (message.action === 'update') {
          const data = message.data;
          alert(data.foo);
          // 在这里处理接收到的数据
          console.log(data.foo); // 输出 'bar'
          console.log(data.baz); // 输出 123
        }
      }
    },
    Selectbtn (val) {
      this.$http.get(`StudentData/GetPreviewFunds?groupId=${val.groupID}`).then((ress) => {
        if (ress.success) {
          this.$http
          .get(
            "StudentData/GetMeun?groupid=" +
            val.groupID +
            "&expid=" +
            val.id +
            "&userid=" +
            val.userId
          )
          .then((res) => {
            if (res.success) {
            this.Global.beforeDestroy();
            localStorage.removeItem("accessToken");
            localStorage.removeItem("CurrentRound");
            localStorage.removeItem("caseId");
            localStorage.removeItem("groupID");
            localStorage.removeItem("Money");
            localStorage.removeItem("msg");
            localStorage.removeItem("SPmsg");
            localStorage.removeItem("floorlist");
            // localStorage.removeItem("selectiveexperiment");
            Cookie.remove("token");
            //Cookie.remove("depcomit");
            localStorage.removeItem("depcomit");
            localStorage.removeItem("operate");
            localStorage.removeItem("checkSummarize");

            Cookie.remove("commit");
            Cookie.remove("round");

              localStorage.setItem("expID", val.id);
              localStorage.setItem("accessToken", res.tnToken.tokenStr);
              localStorage.setItem("refreshToken", res.refreshTnToken.refreshTokenStr);
              localStorage.setItem("groupID", val.groupID);
              localStorage.setItem("userId", val.userId);
              //localStorage.setItem("RoundCount", val.roundCount);
              //this.$store.commit("coomitmd", val.committed);
              //this.$store.commit("roundZeroCommittedmd", val.roundZeroCommitted);
              this.$store.commit("setMoney", ress.dynamicObj);
              this.$store.commit("changeround", val.currentRound);
              this.$store.commit("changedepcomit", 0);
              this.$store.commit("clearMenu");
              localStorage.setItem("caseId", val.caseID);
              // console.log(JSON.stringify(res.dynamicObj))
              localStorage.setItem("Menu", JSON.stringify(res.dynamicObj));
              this.$dycrouter.getrouder();
              if (res.dynamicObj.length == 0) {
                this.$message.error("该账户没有任何权限");
                return;
              }
              this.GetMoney();
              //this.$router.push({ name: res.dynamicObj[0].name });
              this.$router.push('/Main');
            }

          });
        } else {
          return this.$message.error(ress.message)
        }
      })
    },
    GetMoney () {
      this.$http
        .get(
          "User/GetMoney?round=" +
          this.Round
        )
        .then((res) => {
          if (res.success) {
            this.$store.commit("setMoney", res.dynamicObj);
          } else {
            return this.$message.warning(res.message);
          }
        });
    },
    composeValue(acc, command) {
        return {
          "id": acc,
          "command": command
      }
    },
      // 用户名下拉菜单选择事件
      handleCommand (val) {
        console.log(val);
      if (val.command == "histpry") {
        this.$router.push({ path: "History",query: {id : val.id}});
      }else if (val.command == "guide") {
        this.$router.push({ path: "guide",query: {id : val.id}});
      }
      else if (val.command == "topic") {
        let userNames = localStorage.getItem("ms_username");
        //  window.location.href= this.Global.topicurl +"#/Previews?expId="+val.id+"&name="+userNames;
        this.$router.push({ path: "/Previewtopic",query: {id : val.id,userName : userNames}});
      }
      else if (val.command == "loginout") {
         window.open(this.Global.imgip +"【教学指导书】海丝博览会数字化运营虚拟仿真实验.pdf");
      }
      else if (val.command == "subitem1") {
         window.open(this.Global.imgip + "【课件】海丝博览会数字化运营虚拟仿真实验.pptx");
      }
      else if (val.command == "subitem2") {
         window.open(this.Global.imgip +"【教学指导书】海丝博览会数字化运营虚拟仿真实验.pdf");
      }
    },
  },
};
</script>

<style scoped>

.tagdiv {
  width: 100%;
  height: 40px;
  text-align: right;
  padding-top: 10px;
  position: absolute;
  top: 0px;
  right: 40px;
  color: white;
  font-weight: bold;
}
#Main {
  display: flex;
  /* width: 100%;
  height: 100%; */
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  margin: 20px;
  width: 100%;
  overflow-x: hidden;overflow-y: auto;
}

#Main > div {
  width: calc(25% - 20px);
  margin: 10px;
}

.image {
  width: 100%;
  height: 100%;
}
.tool-tip {
  max-width: 400px;
}
</style>
<!-- 新手引导提示样式 -->
<style lang="scss">
.introjs-helperLayer {
  box-shadow: rgba(33, 33, 33, 0.8) 0px 0px 1px 0px,
    rgba(33, 33, 33, 0.5) 0px 0px 0px 5000px !important;
  border: 3px dashed #409eff;
}
.new-tips {
  color: #409eff;
  line-height: 80px;
  cursor: pointer;
}
.introjs-tooltip-title {
  font-size: 16px;
  width: 80%;
  padding-top: 10px;
}
.warper {
  width: 200px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid saddlebrown;
}
/* 重置引导组件样式(类似element-ui个人使用) */
.intro-tooltip {
  color: #ffff;
  background: #2c3e50;
}
/* 引导提示框的位置 */
.introjs-bottom-left-aligned {
  left: 45% !important;
}
.introjs-right,
.introjs-left {
  top: 30%;
}
.intro-highlight {
  background: rgba(255, 255, 255, 0.5);
}
.introjs-arrow.left {
  border-right-color: #2c3e50;
}
.introjs-arrow.top {
  border-bottom-color: #2c3e50;
}
.introjs-arrow.right {
  border-left-color: #2c3e50;
}
.introjs-arrow.bottom {
  border-top-color: #2c3e50;
}
/* 提示框头部区域 */
.introjs-tooltip-header {
  padding-right: 0 !important;
  padding-top: 0 !important;
}
.introjs-skipbutton {
  color: #409eff !important;
  font-size: 14px !important;
  font-weight: normal !important;
  //   padding: 8px 10px !important ;
}
.introjs-tooltipbuttons {
  border: none !important;
}
.introjs-tooltiptext {
  font-size: 14px !important;
  padding: 15px !important;
}
/* 提示框按钮 */
.introjs-tooltipbuttons {
  display: flex;
  align-items: center;
  justify-content: center;
}
.introjs-button {
  width: 50px !important;
  text-align: center;
  padding: 4px !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  border-radius: 3px !important;
  border: none !important;
}
.introjs-button:last-child {
  margin-left: 10px;
}
.introjs-prevbutton {
  color: #606266 !important;
  background: #fff !important;
  border: 1px solid #dcdfe6 !important;
}
.introjs-nextbutton {
  color: #fff !important;
  background-color: #409eff !important;
  border-color: #409eff !important;
}
.introjs-disabled {
  color: #9e9e9e !important;
  border-color: #bdbdbd !important;
  background-color: #f4f4f4 !important;
}
</style>
